import tailwindcssAnimate from "tailwindcss-animate";
import colors from "./assets/colors.js";
import { generateSizes } from "./helper.js";
import iconSizing from "./plugins/icon-sizing.js";
import indicatorArrow from "./plugins/indicatorArrow.js";
import typography from "./plugins/typography.js";
const config = {
    content: [],
    darkMode: ["selector", "body.dark"],
    theme: {
        container: {
            center: true,
            padding: "2rem",
            screens: {
                "2xl": "1400px",
            },
        },
        extend: {
            colors: colors.nonDomainColors,
            backgroundColor: {
                ...colors.backgroundColor,
            },
            fill: {
                ...colors.backgroundColor,
            },
            backgroundImage: {
                ...colors.backgroundImage,
            },
            borderColor: {
                ...colors.borderColor,
                ...colors.iconColor,
                transparent: "transparent",
            },
            ringColor: {
                ...colors.borderColor,
                ...colors.iconColor,
                transparent: "transparent",
            },
            outlineColor: {
                ...colors.borderColor,
                ...colors.iconColor,
                transparent: "transparent",
            },
            textColor: {
                ...colors.textColor,
                ...colors.iconColor,
            },
            borderRadius: {
                sm: "var(--small-border-radius)",
                DEFAULT: "var(--medium-border-radius)",
                // md: 6px -- .375rem
                lg: "var(--large-border-radius)",
                xl: "var(--extra-large-border-radius)",
            },
            minWidth: generateSizes(24),
            // FIXME: shadows are currently not being loaded properly due to two-shadow syntax
            dropShadow: {
                "left-medium": [
                    "0px 0px 2px rgba(18, 18, 18, 0.13)",
                    "-4px 0px 6px rgba(18, 18, 18, 0.13)",
                ],
                "down-medium": "var(--effect-drop-shadow-down-medium)",
            },
        },
        letterSpacing: {
            1: "0em",
            2: "0.025em",
            3: "0.05em",
            4: "0.1em",
            5: "0.25em",
        },
    },
    variants: {
        extend: {
            borderColor: ["disabled"],
            textColor: ["disabled"],
        },
    },
    blocklist: ["table"],
    plugins: [iconSizing, typography, indicatorArrow, tailwindcssAnimate],
};
export default config;
